import { UnitsOfLength } from '@race-planner/aws-amplify/src/models';

export const unitOptions = [
    {
        key: 'km',
        text: 'Kilometers',
        unitsOfLength: UnitsOfLength.METRIC,
        paceUnit: 'per km',
        distanceUnit: 'km'
    },
    {
        key: 'mi',
        text: 'Miles',
        unitsOfLength: UnitsOfLength.STATUTE,
        paceUnit: 'per mi',
        distanceUnit: 'mi'
    }
];
